import "./IndeterminateCheckbox.scss";
import block from "bem-cn";
import React, {
  ChangeEventHandler,
  CSSProperties
} from "react";

const c = block("IndeterminateCheckbox");

type ICProps = {
  indeterminate?: any;
  text: string;
  checked: boolean;
  title: string;
  style: CSSProperties;
  onChange: ChangeEventHandler;
  onChangeEx?: ChangeEventHandler;
};

const IndeterminateCheckbox = React.forwardRef(
  (
    {
      indeterminate,
      text,
      checked,
      title,
      style,
      onChange,
      onChangeEx,
    }: ICProps,
    ref
  ) => {
    const defaultRef = React.useRef();
    const resolvedRef: any = ref || defaultRef;

    React.useEffect(() => {
      (resolvedRef as any).current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <label className={c()}>
        <input
          className={c("input")}
          type="checkbox"
          ref={resolvedRef}
          checked={checked}
          title={title}
          style={style}
          onChange={(e) => {
            onChange(e);
            onChangeEx && onChangeEx(e);
          }}
        />
        <span className={c("text")}>{text}</span>
      </label>
    );
  }
);

export default IndeterminateCheckbox;
